import { render, staticRenderFns } from "./ErrorPrompt.vue?vue&type=template&id=3d085055"
import script from "./ErrorPrompt.vue?vue&type=script&lang=js"
export * from "./ErrorPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports